import React from 'react'
import styles from '../../styles'
import RoundRadioButton from '../../../../../../../../Assets/Images/icons/roundRadioButton'
import SquareCheckBox from '../../../../../../../../Assets/Images/icons/squareCheckBox'
import { TIME_SLOTS } from '../../options'
import {
  convertDayValueToShortName,
  daysScheduleHaveErrors,
  getDefaultDaysSchedule,
  getDefaultTimeSlotSchedule,
  removeDaysScheduleErrors,
  validateBreakTime,
  validateDaysSelector,
  validateTimeSlotsSchedule,
} from '../../utils'
import DaySelector from '../../parts/DaysSelector'
import TimeRanges from '../../parts/TimeRanges'
import ExpandableRow from '../../parts/ExpandableRow'
import TooltipWrapper from '../../../../../../../../Components/_newComponents/TooltipWrapper'
import { LOCATION_SCHEDULE_TYPES_ENUM } from '../../../../../../../../shared/constants'

const WeeklyScheduling = ({
  weeklyScheduleType,
  timeSlotsSchedule,
  setTimeSlotsSchedule,
  weeklyHoursSchedule,
  setWeeklyHoursSchedule,
  dailyHoursSchedule,
  setDailyHoursSchedule,
  setWeeklyScheduleType,
  visible,
  validationErrors,
  handleValidationError,
}) => {
  if (!visible) return null
  const weeklyScheduleTypesOptions = [
    {
      label: 'Time Slots',
      value: LOCATION_SCHEDULE_TYPES_ENUM.TIME_SLOTS,
    },
    {
      label: 'Weekly Hours',
      value: LOCATION_SCHEDULE_TYPES_ENUM.WEEKLY_HOURS,
    },
    {
      label: 'Daily Hours (different hours per day)',
      value: LOCATION_SCHEDULE_TYPES_ENUM.DAILY_HOURS,
    },
  ]

  const onTimeSlotsDayPress = pressedDay => {
    const daySelected = timeSlotsSchedule.find(({ day }) => day === pressedDay)
    const oneOfSelectedItems = timeSlotsSchedule[0]
    const newDaySchedule = oneOfSelectedItems
      ? { ...oneOfSelectedItems, day: pressedDay }
      : getDefaultTimeSlotSchedule(pressedDay)
    const newTimeSlotsSchedule = daySelected
      ? timeSlotsSchedule.filter(({ day }) => day !== pressedDay)
      : [...timeSlotsSchedule, newDaySchedule]
    setTimeSlotsSchedule(newTimeSlotsSchedule)
    validateDaysSelector(newTimeSlotsSchedule, handleValidationError)
    validateTimeSlotsSchedule(newTimeSlotsSchedule, handleValidationError)
  }

  const onWeeklyHoursDayPress = pressedDay => {
    const daySelected = weeklyHoursSchedule.find(
      ({ day }) => day === pressedDay,
    )
    const newWeeklyHoursSchedule = daySelected
      ? weeklyHoursSchedule.filter(({ day }) => day !== pressedDay)
      : [...weeklyHoursSchedule, getDefaultDaysSchedule(pressedDay)]
    setWeeklyHoursSchedule(newWeeklyHoursSchedule)
    validateDaysSelector(newWeeklyHoursSchedule, handleValidationError)
  }

  const onDailyHoursDayPress = pressedDay => {
    const daySelected = dailyHoursSchedule.find(({ day }) => day === pressedDay)
    if (daySelected) {
      removeDaysScheduleErrors(daySelected, handleValidationError)
    }
    const newDailyHoursSchedule = daySelected
      ? dailyHoursSchedule.filter(({ day }) => day !== pressedDay)
      : [...dailyHoursSchedule, getDefaultDaysSchedule(pressedDay)]
    setDailyHoursSchedule(newDailyHoursSchedule)
    validateDaysSelector(newDailyHoursSchedule, handleValidationError)
  }

  const renderDaysSelector = () => {
    if (weeklyScheduleType === LOCATION_SCHEDULE_TYPES_ENUM.TIME_SLOTS) {
      return (
        <DaySelector
          daysSchedule={timeSlotsSchedule}
          onDayPress={onTimeSlotsDayPress}
          validationError={validationErrors['days-selector']}
        />
      )
    } else if (
      weeklyScheduleType === LOCATION_SCHEDULE_TYPES_ENUM.WEEKLY_HOURS
    ) {
      return (
        <DaySelector
          daysSchedule={weeklyHoursSchedule}
          onDayPress={onWeeklyHoursDayPress}
          validationError={validationErrors['days-selector']}
        />
      )
    } else if (
      weeklyScheduleType === LOCATION_SCHEDULE_TYPES_ENUM.DAILY_HOURS
    ) {
      return (
        <DaySelector
          daysSchedule={dailyHoursSchedule}
          onDayPress={onDailyHoursDayPress}
          validationError={validationErrors['days-selector']}
        />
      )
    }
  }

  const handleTimeSlotPress = pressedTimeSlot => {
    const timeSlotSelected = timeSlotsSchedule[0].slots[pressedTimeSlot]

    const newTimeSlotsSchedule = timeSlotSelected
      ? timeSlotsSchedule.map(day => ({
          ...day,
          slots: {
            ...day.slots,
            [pressedTimeSlot]: false,
          },
        }))
      : timeSlotsSchedule.map(day => ({
          ...day,
          slots: {
            ...day.slots,
            [pressedTimeSlot]: true,
          },
        }))
    setTimeSlotsSchedule(newTimeSlotsSchedule)
    validateTimeSlotsSchedule(newTimeSlotsSchedule, handleValidationError)
  }
  const daysSelected =
    weeklyScheduleType === LOCATION_SCHEDULE_TYPES_ENUM.TIME_SLOTS
      ? timeSlotsSchedule.length > 0
      : weeklyScheduleType === LOCATION_SCHEDULE_TYPES_ENUM.WEEKLY_HOURS
      ? weeklyHoursSchedule.length > 0
      : dailyHoursSchedule.length > 0

  const onWeeklyBreakTimeStartChange = (id, time) => {
    const newWeeklySchedule = weeklyHoursSchedule.map(daySchedule => {
      return {
        ...daySchedule,
        hours: daySchedule.hours.map(hour =>
          hour.id === id ? { ...hour, start: time } : hour,
        ),
      }
    })
    setWeeklyHoursSchedule(newWeeklySchedule)
    const validatedRange = newWeeklySchedule[0].hours.find(
      hour => hour.id === id,
    )
    validateBreakTime(
      id,
      time,
      validatedRange.end,
      'start',
      handleValidationError,
      newWeeklySchedule[0].hours,
      'weekly-hours',
    )
  }

  const onWeeklyBreakTimeEndChange = (id, time) => {
    const newWeeklySchedule = weeklyHoursSchedule.map(daySchedule => {
      return {
        ...daySchedule,
        hours: daySchedule.hours.map(hour =>
          hour.id === id ? { ...hour, end: time } : hour,
        ),
      }
    })
    setWeeklyHoursSchedule(newWeeklySchedule)
    const validatedRange = newWeeklySchedule[0].hours.find(
      hour => hour.id === id,
    )
    validateBreakTime(
      id,
      validatedRange.start,
      time,
      'end',
      handleValidationError,
      newWeeklySchedule[0].hours,
      'weekly-hours',
    )
  }

  const onWeeklyBreakTimeRemove = id => {
    const newWeeklySchedule = weeklyHoursSchedule.map(daySchedule => {
      return {
        ...daySchedule,
        hours: daySchedule.hours.filter(hour => hour.id !== id),
      }
    })
    setWeeklyHoursSchedule(newWeeklySchedule)
  }

  const handleAddWeeklyBreakTime = () => {
    const newWeeklySchedule = weeklyHoursSchedule.map(daySchedule => {
      return {
        ...daySchedule,
        hours: [
          ...daySchedule.hours,
          {
            id: Math.max(...daySchedule.hours.map(hour => hour.id), 0) + 1,
            start: null,
            end: null,
          },
        ],
      }
    })
    setWeeklyHoursSchedule(newWeeklySchedule)
  }

  const onDailyBreakTimeStartChange = (hoursId, time, dayId) => {
    const daySchedule = dailyHoursSchedule.find(
      daySchedule => daySchedule.day === dayId,
    )
    const newDaySchedule = {
      ...daySchedule,
      hours: daySchedule.hours.map(hour =>
        hour.id === hoursId ? { ...hour, start: time } : hour,
      ),
    }
    const newDailySchedule = dailyHoursSchedule.map(daySchedule =>
      daySchedule.day === dayId ? newDaySchedule : daySchedule,
    )
    setDailyHoursSchedule(newDailySchedule)

    const editedRange = newDaySchedule.hours.find(hour => hour.id === hoursId)
    validateBreakTime(
      hoursId,
      time,
      editedRange.end,
      'start',
      handleValidationError,
      newDaySchedule.hours,
      `${dayId}-daily-hours`,
    )
  }

  const onDailyBreakTimeEndChange = (hoursId, time, dayId) => {
    const daySchedule = dailyHoursSchedule.find(
      daySchedule => daySchedule.day === dayId,
    )
    const newDaySchedule = {
      ...daySchedule,
      hours: daySchedule.hours.map(hour =>
        hour.id === hoursId ? { ...hour, end: time } : hour,
      ),
    }
    const newDailySchedule = dailyHoursSchedule.map(daySchedule =>
      daySchedule.day === dayId ? newDaySchedule : daySchedule,
    )

    setDailyHoursSchedule(newDailySchedule)
    const editedRange = newDaySchedule.hours.find(hour => hour.id === hoursId)
    validateBreakTime(
      hoursId,
      editedRange.start,
      time,
      'end',
      handleValidationError,
      newDaySchedule.hours,
      `${dayId}-daily-hours`,
    )
  }

  const handleAddDailyBreakTime = dayId => {
    const newDailySchedule = dailyHoursSchedule.map(daySchedule =>
      daySchedule.day === dayId
        ? {
            ...daySchedule,
            hours: [
              ...daySchedule.hours,
              {
                id: Math.max(...daySchedule.hours.map(hour => hour.id), 0) + 1,
                start: null,
                end: null,
              },
            ],
          }
        : daySchedule,
    )
    setDailyHoursSchedule(newDailySchedule)
  }

  const onDailyBreakTimeRemove = (hoursId, dayId) => {
    const newDailySchedule = dailyHoursSchedule.map(daySchedule =>
      daySchedule.day === dayId
        ? {
            ...daySchedule,
            hours: daySchedule.hours.filter(hour => hour.id !== hoursId),
          }
        : daySchedule,
    )
    setDailyHoursSchedule(newDailySchedule)
  }

  const handleWeeklyScheduleTypeChange = value => {
    setWeeklyScheduleType(value)
    handleValidationError('days-selector', null)
  }

  const getDaysTooltipContent = () => {
    if (weeklyScheduleType === LOCATION_SCHEDULE_TYPES_ENUM.WEEKLY_HOURS) {
      return `You can add 'break' times for the location 3 times.`
    } else if (
      weeklyScheduleType === LOCATION_SCHEDULE_TYPES_ENUM.DAILY_HOURS
    ) {
      return 'Select this option to set unique opening and closing hours for each day of the week. This is ideal for locations with schedules that vary daily, such as late-night hours on weekends.'
    } else {
      return null
    }
  }
  const daysTooltipContent = getDaysTooltipContent()

  return (
    <div style={styles.contentArea}>
      <div style={styles.headerSchedulingContainer}>
        <div style={{ ...styles.contentTitle, cursor: 'pointer' }}>
          Weekly Schedule
        </div>
        <div style={{ ...pageStyles.subtitle, alignSelf: 'flex-start' }}>
          Define the dates this location is operational in a week.
        </div>
      </div>

      <div style={styles.blockContainer}>
        <div style={pageStyles.titleSmall}>Times</div>
        <div style={{ ...pageStyles.subtitle, alignSelf: 'flex-start' }}>
          Select the scheduling mode fitting for this location and define
          available times for it.
        </div>
        <div style={pageStyles.rowContainerWithGap}>
          {weeklyScheduleTypesOptions.map(option => (
            <div
              key={option.value}
              style={pageStyles.scheduleTypeContainer}
              onClick={() => handleWeeklyScheduleTypeChange(option.value)}
            >
              <RoundRadioButton active={weeklyScheduleType === option.value} />
              <div style={{ ...pageStyles.subtitle }}>{option.label}</div>
            </div>
          ))}
        </div>
      </div>

      <div style={styles.blockContainer}>
        {daysTooltipContent ? (
          <TooltipWrapper description={daysTooltipContent}>
            <div style={{ ...pageStyles.titleSmall, cursor: 'pointer' }}>
              Days ⓘ
            </div>
          </TooltipWrapper>
        ) : (
          <div style={pageStyles.titleSmall}>Days</div>
        )}
        {renderDaysSelector()}
      </div>

      {weeklyScheduleType === LOCATION_SCHEDULE_TYPES_ENUM.TIME_SLOTS &&
        daysSelected && (
          <div style={styles.blockContainer}>
            <div style={styles.headerSchedulingContainer}>
              <div style={pageStyles.titleSmallThin}>Time Slots</div>
            </div>
            <div style={pageStyles.rowContainerWithGap}>
              {TIME_SLOTS.map(option => (
                <div
                  key={option.value}
                  style={pageStyles.timeShiftsContainer}
                  onClick={() => handleTimeSlotPress(option.value)}
                >
                  <SquareCheckBox
                    active={timeSlotsSchedule[0].slots[option.value]}
                  />
                  <div style={{ height: 25 }}>{option.icon}</div>
                  <div style={pageStyles.timeShiftTitle}>{option.label}</div>
                </div>
              ))}
            </div>
            {validationErrors['time-slots'] && (
              <div style={pageStyles.errorMessage}>
                {validationErrors['time-slots']}
              </div>
            )}
          </div>
        )}
      {weeklyScheduleType === LOCATION_SCHEDULE_TYPES_ENUM.WEEKLY_HOURS &&
        daysSelected && (
          <TimeRanges
            timeRanges={weeklyHoursSchedule[0].hours}
            onStartChange={onWeeklyBreakTimeStartChange}
            onEndChange={onWeeklyBreakTimeEndChange}
            onRemove={onWeeklyBreakTimeRemove}
            handleAddTime={handleAddWeeklyBreakTime}
            validationErrors={validationErrors}
            handleValidationError={handleValidationError}
            errorKey="weekly-hours"
          />
        )}
      {weeklyScheduleType === LOCATION_SCHEDULE_TYPES_ENUM.DAILY_HOURS &&
        daysSelected &&
        dailyHoursSchedule.map(daySchedule => {
          const hasError = daysScheduleHaveErrors(
            daySchedule.day,
            daySchedule.hours,
            validationErrors,
          )

          return (
            <ExpandableRow
              title={convertDayValueToShortName(daySchedule.day)}
              key={daySchedule.day}
              hasError={hasError}
            >
              <TimeRanges
                timeRanges={daySchedule.hours}
                onStartChange={(id, time) =>
                  onDailyBreakTimeStartChange(id, time, daySchedule.day)
                }
                onEndChange={(id, time) =>
                  onDailyBreakTimeEndChange(id, time, daySchedule.day)
                }
                onRemove={hoursId =>
                  onDailyBreakTimeRemove(hoursId, daySchedule.day)
                }
                handleAddTime={() => handleAddDailyBreakTime(daySchedule.day)}
                validationErrors={validationErrors}
                handleValidationError={handleValidationError}
                errorKey={`${daySchedule.day}-daily-hours`}
              />
            </ExpandableRow>
          )
        })}
      {!daysSelected && (
        <div style={{ ...pageStyles.subtitle }}>
          Please select a day to enable time slots
        </div>
      )}
    </div>
  )
}

export default WeeklyScheduling

const pageStyles = {
  rowContainerWithGap: {
    display: 'flex',
    flexDirection: 'row',
    gap: '10px',
  },
  subtitle: {
    color: '#707087',
    fontSize: 14,
    fontWeight: 400,
    lineHeight: '18px',
  },
  inputsContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    width: '100%',
  },
  datePickerInput: error => ({
    backgroundColor: 'white',
    width: '100%',
    height: 32,
    paddingLeft: 16,
    paddingRight: 40,
    borderRadius: 8,
    border: '1px solid #E2E2FC',
    borderColor: error ? '#FF0000' : '#E2E2FC',
  }),
  datePickerContainer: {
    width: '48%',
  },
  breakTimesContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
    alignItems: 'center',
  },
  addButton: {
    width: 'fit-content',
    background: 'transparent',
    border: 'none',
    padding: 0,
  },
  errorMessage: {
    color: 'red',
    fontSize: 12,
    fontWeight: 400,
    lineHeight: '18px',
  },

  titleSmall: {
    color: '#707087',
    fontSize: 14,
    fontWeight: 600,
    lineHeight: '18px',
  },
  titleSmallThin: {
    color: '#707087',
    fontSize: 14,
    fontWeight: 400,
    lineHeight: '18px',
  },
  timeShiftTitle: {
    color: '#707087',
    fontSize: 14,
    fontWeight: 700,
    lineHeight: '22px',
  },
  scheduleTypeContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'row',
    cursor: 'pointer',
    gap: 4,
  },
  timeShiftsContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'row',
    cursor: 'pointer',
    gap: 4,
  },
}
